/* Cazah: kits de desconto progressivo com variantes por unidade */
(function () {
  if (customElements.get('cz-kits-progressivos')) return;

  var fmt = null;
  try { fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }); } catch (e) {}
  function money(cents) {
    var v = (cents || 0) / 100;
    return fmt ? fmt.format(v) : 'R$ ' + v.toFixed(2).replace('.', ',');
  }
  function discUnit(price, pct) {
    return Math.max(0, Math.ceil(price * pct / 100 - 0.5));
  }
  function readJSON(el) {
    try { return JSON.parse(el ? el.textContent : 'null'); } catch (e) { return null; }
  }

  class CzKits extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (this.closest('.quick-add-modal__content, #quick-add-modal-content, .quick-add-modal, quick-add-dialog')) {
        this.style.display = 'none';
        return;
      }
      this._ready = true;
      this.variants = readJSON(this.querySelector('[data-czk-variants]')) || [];
      this.optionNames = readJSON(this.querySelector('[data-czk-options]')) || [];
      this.hasOpts = this.classList.contains('czk--opts');
      this.basePrice = parseInt(this.dataset.price, 10) || 0;
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.czk__card'));
      this.active = 1;
      this._syncing = false;

      var sc = this.scope();
      if (sc && sc.classList) sc.classList.add('czk-on');

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onVariant = this.onVariant.bind(this);
      this.onAtcClick = this.onAtcClick.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      document.addEventListener('variant:update', this.onVariant);
      document.addEventListener('click', this.onAtcClick, true);

      this.render();
      var selfInit = this;
      setTimeout(function () { selfInit.watchBar(); }, 300);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.onVariant);
      document.removeEventListener('click', this.onAtcClick, true);
      if (this._barObs) { this._barObs.disconnect(); this._barObs = null; }
      this._ready = false;
    }

    scope() {
      var near = this.closest('.group-block-content');
      if (near && near.querySelector('product-form-component form')) return near;
      return this.closest('.product-details, .product-information, .shopify-section') || document;
    }

    form() {
      return this.scope().querySelector('product-form-component form');
    }

    activeCard() {
      var q = this.active;
      return this.cards.filter(function (c) { return parseInt(c.dataset.qty, 10) === q; })[0];
    }

    rowOptions(row) {
      return Array.prototype.slice.call(row.querySelectorAll('.czk__sel')).map(function (s) { return s.value; });
    }

    findVariant(opts) {
      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (String(v.options[j]) !== String(opts[j])) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    currentFormVariant() {
      var f = this.form();
      var id = f && f.querySelector('input[name="id"]') ? f.querySelector('input[name="id"]').value : null;
      return this.variants.filter(function (v) { return String(v.id) === String(id); })[0] || null;
    }

    setRow(row, variant) {
      if (!row || !variant) return;
      var sels = row.querySelectorAll('.czk__sel');
      for (var i = 0; i < sels.length; i++) {
        if (variant.options[i] != null) sels[i].value = variant.options[i];
      }
    }

    unitsOf(card) {
      var q = parseInt(card.dataset.qty, 10) || 1;
      var units = [];
      if (!this.hasOpts) {
        var v = this.variants[0] || { id: null, price: this.basePrice, available: true };
        var cv = this.currentFormVariant() || v;
        for (var k = 0; k < q; k++) units.push(cv);
        return units;
      }
      var rows = card.querySelectorAll('.czk__row');
      for (var i = 0; i < rows.length; i++) units.push(this.findVariant(this.rowOptions(rows[i])));
      return units;
    }

    onClick(e) {
      var opt = e.target.closest('.czk__opt');
      if (!opt || !this.contains(opt)) return;
      e.preventDefault();
      var card = opt.closest('.czk__card');
      var q = parseInt(card.dataset.qty, 10) || 1;
      this.setActive(q);
      var f = this.form();
      var qi = f && f.querySelector('input[name="quantity"]');
      if (qi) qi.value = q;
    }

    onChange(e) {
      var sel = e.target.closest && e.target.closest('.czk__sel');
      if (!sel) return;
      var row = sel.closest('.czk__row');
      var card = sel.closest('.czk__card');
      var rowIdx = row.dataset.row;
      var optIdx = sel.dataset.opt;
      var master = rowIdx === '1';
      /* #1 vale para as unidades que o cliente ainda não mudou; as outras mantêm a escolha em todos os kits */
      this.cards.forEach(function (c) {
        c.querySelectorAll('.czk__row').forEach(function (r) {
          var same = r.dataset.row === rowIdx;
          if (r === row) return;
          if (same || (master && r.dataset.touched !== '1')) {
            var s = r.querySelector('.czk__sel[data-opt="' + optIdx + '"]');
            if (s) s.value = sel.value;
            if (same && !master) r.dataset.touched = '1';
          }
        });
      });
      if (!master) row.dataset.touched = '1';
      var variant = this.findVariant(this.rowOptions(row));
      this.render();
      if (variant) this.syncNative(variant);
    }

    onVariant(e) {
      var d = e.detail || {};
      var pid = d.data && d.data.productId;
      if (pid && String(pid) !== String(this.dataset.productId)) return;
      if (this._syncing) {
        this._syncing = false;
        return;
      }
      var v = d.resource;
      if (!v || !v.id) return;
      var self = this;
      var full = this.variants.filter(function (x) { return String(x.id) === String(v.id); })[0] || v;
      this.cards.forEach(function (c) { self.setRow(c.querySelector('.czk__row[data-row="1"]'), full); });
      this.render();
    }

    /* Atualiza o seletor original (escondido) para trocar foto, preço e a barra fixa do celular */
    fieldsetFor(picker, name, i) {
      var groups = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
      var want = String(name).trim().toLowerCase();
      /* 1) pelo nome do input (ex.: "Size-..."), que não é traduzido */
      for (var k = 0; k < groups.length; k++) {
        var inp = groups[k].querySelector('input[type="radio"], select');
        var nm = inp ? String(inp.getAttribute('name') || '').toLowerCase() : '';
        if (nm.indexOf(want + '-') === 0 || nm === 'options[' + want + ']') return groups[k];
      }
      if (groups.length === this.optionNames.length && groups[i]) return groups[i];
      for (var g = 0; g < groups.length; g++) {
        var lg = groups[g].querySelector('legend');
        if (lg && lg.textContent.trim().toLowerCase().indexOf(want) === 0) return groups[g];
      }
      return null;
    }

    syncNative(variant) {
      var picker = this.scope().querySelector('variant-picker');
      if (!picker) return;
      var current = this.currentFormVariant();
      if (current && String(current.id) === String(variant.id)) return;
      var self = this;
      this._syncing = true;
      clearTimeout(this._syncTimer);
      this._syncTimer = setTimeout(function () { self._syncing = false; }, 4000);
      this.optionNames.forEach(function (name, i) {
        var value = variant.options[i];
        var fs = self.fieldsetFor(picker, name, i);
        if (!fs) return;
        var radios = fs.querySelectorAll('input[type="radio"]');
        for (var r = 0; r < radios.length; r++) {
          if (radios[r].value === value && !radios[r].checked) { radios[r].click(); }
        }
        var sel = fs.querySelector('select');
        if (sel && sel.value !== value) {
          sel.value = value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /* ---------- barra fixa do celular (cz-buybar) ---------- */
    barTexts() {
      var card = this.activeCard();
      if (!card) return null;
      var q = parseInt(card.dataset.qty, 10) || 1;
      var units = this.unitsOf(card);
      var label = '';
      if (this.hasOpts) {
        var first = units[0];
        var same = units.every(function (v) { return v && first && String(v.id) === String(first.id); });
        var name = first ? first.options.map(function (o) { return String(o).split(' (')[0]; }).join(' · ') : '';
        label = q > 1 ? q + ' un. · ' + (same ? name : 'variados') : name;
      } else if (q > 1) {
        label = q + ' unidades';
      }
      var pct = parseInt(card.dataset.pct, 10) || 0;
      var total = 0;
      var self = this;
      units.forEach(function (v) {
        var p = v && v.price != null ? parseInt(v.price, 10) : self.basePrice;
        total += p - discUnit(p, pct);
      });
      return { label: label, price: money(total) };
    }

    updateBar() {
      var bar = document.querySelector('.cz-buybar');
      if (!bar || !this.offsetParent) return;
      var t = this.barTexts();
      if (!t) return;
      var v = bar.querySelector('[data-cz-var]');
      var p = bar.querySelector('[data-cz-price]');
      if (v && t.label && v.textContent !== t.label) v.textContent = t.label;
      if (p && p.textContent !== t.price) p.textContent = t.price;
    }

    watchBar() {
      var bar = document.querySelector('.cz-buybar');
      if (!bar || this._barObs || !this.offsetParent) return;
      var self = this;
      var pending = false;
      this._barObs = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; self.updateBar(); });
      });
      this._barObs.observe(bar, { childList: true, subtree: true, characterData: true });
      /* tocar no nome da variante na barra leva aos kits (o seletor original fica escondido) */
      var go = bar.querySelector('[data-cz-goto]');
      if (go) {
        go.addEventListener('click', function (e) {
          if (!self.offsetParent) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          self.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, true);
      }
      this.updateBar();
    }

    setActive(q) {
      this.active = q;
      this.cards.forEach(function (c) {
        var on = parseInt(c.dataset.qty, 10) === q;
        c.classList.toggle('is-active', on);
        var b = c.querySelector('.czk__opt');
        if (b) b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      this.hideMsg();
      this.render();
    }

    render() {
      var self = this;
      this.cards.forEach(function (card) {
        var pct = parseInt(card.dataset.pct, 10) || 0;
        var q = parseInt(card.dataset.qty, 10) || 1;
        var units = self.unitsOf(card);
        var gross = 0, disc = 0, same = true, firstPrice = null, missing = false;
        units.forEach(function (v) {
          var p = v && v.price != null ? parseInt(v.price, 10) : self.basePrice;
          if (!v || v.available === false) missing = true;
          if (firstPrice === null) firstPrice = p; else if (p !== firstPrice) same = false;
          gross += p;
          disc += discUnit(p, pct);
        });
        var total = gross - disc;
        var t = card.querySelector('[data-czk-total]');
        var w = card.querySelector('[data-czk-was]');
        var u = card.querySelector('[data-czk-unit]');
        var sv = card.querySelector('[data-czk-save]');
        if (t) t.textContent = money(total);
        if (w) w.textContent = money(gross);
        if (u && q > 1) u.textContent = same ? money(total / q) + ' cada' : '';
        if (sv) sv.textContent = 'Economize ' + money(disc);

        if (self.hasOpts) {
          var rows = card.querySelectorAll('.czk__row');
          for (var i = 0; i < rows.length; i++) {
            var rv = units[i];
            rows[i].classList.toggle('is-unavailable', !rv || rv.available === false);
          }
          var err = card.querySelector('[data-czk-err]');
          if (err) {
            err.hidden = !missing;
            err.textContent = missing ? 'Essa combinação está esgotada. Escolha outra cor ou tamanho.' : '';
          }
        }
      });
      this.updateBar();
    }

    /* ---------- adicionar ao carrinho ---------- */
    /* O botão de comprar (e a barra fixa do celular, que clica nele) adiciona o kit escolhido */
    onAtcClick(e) {
      var b = e.target.closest && e.target.closest('button[type="submit"], [ref="addToCartButton"]');
      if (!b) return;
      var f = this.form();
      if (!f || !f.contains(b)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      this.addToCart();
    }

    showMsg(text) {
      var m = this.querySelector('[data-czk-msg]');
      if (!m) return;
      m.textContent = text;
      m.hidden = false;
    }

    hideMsg() {
      var m = this.querySelector('[data-czk-msg]');
      if (m) m.hidden = true;
    }

    addToCart() {
      var self = this;
      if (this._busy) return;
      var card = this.activeCard();
      if (!card) return;
      var units = this.unitsOf(card);
      var bad = units.some(function (v) { return !v || !v.id || v.available === false; });
      if (bad) {
        this.showMsg('Escolha uma cor e um tamanho disponíveis para todas as unidades.');
        return;
      }
      this.hideMsg();

      var grouped = [];
      units.forEach(function (v) {
        var found = grouped.filter(function (g) { return String(g.id) === String(v.id); })[0];
        if (found) found.quantity += 1; else grouped.push({ id: v.id, quantity: 1 });
      });

      var btn = this.scope().querySelector('product-form-component [ref="addToCartButton"], product-form-component button[type="submit"]');
      this._busy = true;
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.7'; }

      // Cazah: pede o carrinho lateral atualizado junto com a adição, para ele abrir já com o produto
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        var sid = el.dataset && el.dataset.sectionId;
        if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
      });
      var payload = { items: grouped };
      if (sectionIds.length) {
        payload.sections = sectionIds.join(',');
        payload.sections_url = window.location.pathname;
      }
      var sections = null;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            self.showMsg((res.body && (res.body.description || res.body.message)) || 'Não foi possível adicionar ao carrinho.');
            return null;
          }
          sections = (res.body && res.body.sections) || null;
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          var ev = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'cz-kits',
              data: { source: 'cz-kits', itemCount: cart.item_count, productId: self.dataset.productId, sections: sections }
            }
          });
          self.dispatchEvent(ev);
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
        })
        .catch(function () {
          self.showMsg('Não foi possível adicionar ao carrinho. Tente novamente.');
        })
        .finally(function () {
          self._busy = false;
          if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; }
        });
    }
  }

  customElements.define('cz-kits-progressivos', CzKits);
})();